import React from 'react';
import { Container, Eyebrow, Section } from './Section';
import { DoodleUnderline } from '../brand/Doodles';
type PageHeaderProps = {
  eyebrow: string;
  title: string;
  intro?: string;
};
export function PageHeader({
  eyebrow,
  title,
  intro
}: PageHeaderProps) {
  return <Section className="bcm-paper py-14 sm:py-18" data-id="element-452" data-mp="prupwy4ofv6m">
      <Container data-id="element-453" data-mp="psm919h380g0">
        <Eyebrow data-id="element-454" data-mp="pt5v92drtazu">{eyebrow}</Eyebrow>
        <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-455" data-mp="ttppny6ym0ia">
          {title}
        </h1>
        <DoodleUnderline className="mt-3 h-3.5 w-40" color="var(--bcm-yellow)" data-id="element-456" data-mp="yqpte2gc6r68" />
        {intro ? <p className="mt-6 max-w-2xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-457" data-mp="13lca8l56tbxp">{intro}</p> : null}
      </Container>
    </Section>;
}